import React from 'react';
import { formatAffairDate } from '../../affairs/affairFormatters';
import PartnerRelatedItemsTable from './PartnerRelatedItemsTable';

const origin = (row) => row.projectId || row.project_id ? 'Projet' : row.affairId || row.affair_id ? 'Affaire' : 'Partenaire';
const documentUrl = (row) => {
  const value = row.openUrl || row.open_url || row.url || row.webUrl || row.web_url || '';
  return /^(https?:\/\/|\/)/i.test(value) ? value : null;
};
const columns = [
  { key: 'name', label: 'Document', render: (row) => row.name || '—' },
  { key: 'category', label: 'Catégorie', render: (row) => row.category || row.documentType || row.document_type || '—' },
  { key: 'origin', label: 'Origine', render: origin },
  { key: 'scope', label: 'Portée', render: (row) => row.documentScope || row.document_scope || '—' },
  { key: 'date', label: 'Date', render: (row) => formatAffairDate(row.createdAt || row.created_at) },
  { key: 'action', label: 'Action', render: (row) => documentUrl(row) ? <a className="basic-button" href={documentUrl(row)} target="_blank" rel="noreferrer" onClick={(event) => event.stopPropagation()}>Ouvrir</a> : '—' },
];

export default function PartnerDocumentsPanel({ rows }) {
  return <section className="partner-section"><PartnerRelatedItemsTable rows={rows} columns={columns} emptyMessage="Aucun document lié." /></section>;
}
